export const FASI_NOMI = [
  "Apertura", "Triage", "Assegnazione", "Dati intervento",
  "Consuntivo", "Conferma cliente", "Fatturazione", "Chiusura"
];

export function faseClass(stato) {
  if (stato === "Completata") return "fase-completata";
  if (stato === "In lavorazione") return "fase-inlavorazione";
  if (stato === "Non applicabile") return "fase-na";
  return "fase-dafare";
}

export function statoClass(stato) {
  const s = (stato || "").toLowerCase();
  if (s.includes("chius")) return "stato-chiuso";
  if (s.includes("attesa")) return "stato-attesa";
  if (s.includes("riap")) return "stato-riaperto";
  if (s.includes("annull")) return "stato-annullato";
  if (s.includes("sosp")) return "stato-sospeso";
  return "stato-aperto";
}

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    const d = typeof iso === "string" ? new Date(iso) : iso;
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return iso; }
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}

export function fmtCurrency(n) {
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n || 0));
}

export function computeStato(ticket) {
  if (ticket.stato === "Chiuso") return "Chiuso";
  if (ticket.stato === "Riaperto") return "Riaperto";
  if (ticket.stato === "In attesa cliente") return "In attesa cliente";
  if (ticket.stato === "Sospeso") return "Sospeso";
  if (ticket.stato === "Annullato") return "Annullato";
  return "OnGoing";
}

export function faseStato(ticket, num) {
  const f = ticket.fasi?.find(x => x.num === num);
  return f?.stato || "Da fare";
}

export function isReadyForFatturazione(ticket) {
  return faseStato(ticket, 5) === "Completata" && faseStato(ticket, 6) === "Completata"
    && faseStato(ticket, 7) !== "Completata";
}
